import '../styles/pages/Contact.scss'
import confiance from '../assets/icons/confiance.svg'
import qualite from '../assets/icons/qualite.svg'
import cadeau from '../assets/icons/cadeau.svg'
import ecology from '../assets/icons/ecologie.svg'
import { CiMail } from "react-icons/ci";
import { FiPhone } from "react-icons/fi";
import { useState } from 'react';
import axios from 'axios';
import { SERVER } from '../hooks/config';

const chars = [
    {
        icon : confiance,
        title: 'Une relation de Confiance',
        description: 'La transparence, l’écoute et la <br />satisfaction client sont au cœur<br />de notre démarche. Chaque<br />commande est traitée comme<br />une promesse à tenir.'
    },
    {
        icon : qualite,
        title: 'Une marque 100% tunisienne',
        description: 'Fier·e·s de nos racines, nous <br />soutenons l’artisanat local,<br />en valorisant le savoir-faire<br />tunisien et les talents<br />de chez nous'
    },
    {
        icon : cadeau,
        title: 'Cadeaux personnalisés et uniques',
        description: 'Parce que chaque personne est<br />différente, nous proposons<br />des créations sur-mesure,<br />pensées pour faire plaisir<br />avec sincérité.'
    },
    {
        icon : ecology,
        title: 'Une démarche responsable',
        description: 'Nous privilégions les matériaux<br />durables, éthiques et respectueux<br />de l’environnement, pour des<br />choix plus conscients.'
    }
]

const Contact = () => {
    const [formData, setFormData] = useState({
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        message: ''
    });
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [submitStatus, setSubmitStatus] = useState({ success: false, message: '' });

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        setSubmitStatus({ success: false, message: '' });

        try {
            const response = await axios.post(`${SERVER}/contacts`, formData);
            setSubmitStatus({ 
                success: true, 
                message: 'Votre message a été envoyé avec succès ! Nous vous répondrons bientôt.' 
            });
            // Reset form
            setFormData({
                firstName: '',
                lastName: '',
                email: '',
                phone: '',
                message: ''
            });
        } catch (error) {
            console.error('Error submitting contact form:', error);
            const errorMessage = error.response?.data?.error || 
                               'Une erreur est survenue lors de l\'envoi du message. Veuillez réessayer.';
            setSubmitStatus({ 
                success: false, 
                message: errorMessage 
            });
        } finally {
            setIsSubmitting(false);
        }
    };

    return(
        <div className="contact">
            <div className='contact-container'>
                <div className='layer-1'>
                    <h1> NOS{window.innerWidth > 768 ? <br/> : ' '}ADRESSES </h1>
                    <div className='contact-reach'>
                        <p> <CiMail /> Michkette.tn01@gmail.com  </p>
                        <p> <FiPhone /> +216 99727060  </p>
                    </div>
                </div>
                <form className='contact-form' onSubmit={handleSubmit}>
                    <h2> Nous{window.innerWidth > 768 ? <br/> : ' '}contacter </h2>
                    <input 
                        type='text' 
                        name='firstName'
                        placeholder='Votre nom' 
                        value={formData.firstName}
                        onChange={handleInputChange}
                        required
                    />
                    <input 
                        type='text' 
                        name='lastName'
                        placeholder='Votre prénom' 
                        value={formData.lastName}
                        onChange={handleInputChange}
                        required
                    />
                    <input 
                        type='email' 
                        name='email'
                        placeholder='Votre adresse mail' 
                        value={formData.email}
                        onChange={handleInputChange}
                        required
                    />
                    <input 
                        type='text' 
                        name='phone'
                        placeholder='Votre numéro de téléphone' 
                        value={formData.phone}
                        onChange={handleInputChange}
                    />
                    <textarea 
                        name='message'
                        placeholder='Votre message' 
                        value={formData.message}
                        onChange={handleInputChange}
                        required
                    />
                    {submitStatus.message && (
                        <div className={`submit-message ${submitStatus.success ? 'success' : 'error'}`}>
                            {submitStatus.message}
                        </div>
                    )}
                    <button type='submit' disabled={isSubmitting}>
                        {isSubmitting ? 'Envoi en cours...' : 'Envoyer'}
                    </button>
                </form>
            </div>
            <div className='qualities'>
                {chars.map((char, index) => (
                    <div key={index} className='quality-card'>
                        <img src={char.icon} alt={char.title} />
                        <h3> {char.title} </h3>
                        <p dangerouslySetInnerHTML={{ __html: char.description }} />
                    </div>
                ))}
            </div>
        </div>
    )
}

export default Contact;